<template>
  <BaseCard class="relative overflow-hidden">
    <ProgramRefreshProgressBar v-if="refreshing" />
    <BaseCardBody>
      <div class="mb-5 flex items-center justify-between gap-4">
        <h3 class="text-xl leading-6 font-medium text-gray-900">
          Statistiques
        </h3>
        <ProgramDataRefresh
          label="Actualiser les données du programme"
          date-prefix="Données du"
          :cached-at="cachedAt"
          :loading="!!refreshing"
          :refreshed-at="refreshedAt"
          @refresh="emits('refresh')"
        />
      </div>
      <div v-if="!supportProgram.meta.options.hideGroups && settings">
        <ProgramDigestCards
          v-if="hasExcluded"
          :statistics-included="supportProgram.statistics.included"
          :statistics-excluded="supportProgram.statistics.excluded"
        />
        <ProgramDigestGroups
          :data="supportProgram"
          :has-excluded="hasExcluded"
          :settings="settings"
          @update:group-settings="(slug, enabled) => updateGroupSettings(slug, enabled)"
        />
      </div>
      <ProgramKeyIndicators
        v-if="marketStatistics?.length"
        :stats="marketStatistics"
        :support-program-id="supportProgram.id"
      />
    </BaseCardBody>
  </BaseCard>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import BaseCard from '@/core/components/base/BaseCard.vue';
import BaseCardBody from '@/core/components/base/BaseCardBody.vue';
import ProgramDigestCards from '@/program/components/program-statistics/ProgramDigestCards.vue';
import ProgramDigestGroups from '@/program/components/program-statistics/ProgramDigestGroups.vue';
import ProgramKeyIndicators from '@/program/components/program-statistics/ProgramKeyIndicators.vue';
import ProgramDataRefresh from '@/program/components/program-refresh/ProgramDataRefresh.vue';
import ProgramRefreshProgressBar from '@/program/components/program-refresh/ProgramRefreshProgressBar.vue';
import {
    SupportProgram,
    SupportProgramMarketStatistic,
    SupportProgramSettings
} from "@/program/interfaces/Program";

const {supportProgram, marketStatistics, settings, refreshing, refreshedAt, cachedAt} = defineProps<{
    supportProgram: SupportProgram;
    marketStatistics: SupportProgramMarketStatistic[];
    settings: SupportProgramSettings;
    refreshing?: boolean;
    refreshedAt?: number | null;
    cachedAt?: string | null;
}>();

const emits = defineEmits<{
    (e: 'update:group-settings', slug: string, enabled: boolean): void
    (e: 'refresh'): void
}>();

/**
 * Update group settings when toggled.
 */
const updateGroupSettings = async (slug: string, enabled: boolean) => {
    emits("update:group-settings", slug, enabled);
};

/**
 * Determine if there are excluded groups in the support program.
 */
const hasExcluded = computed(() => {
    const excludedGroups = supportProgram.meta.excluded;

    return (Array.isArray(excludedGroups) && excludedGroups.length > 0)
        || (typeof excludedGroups === 'object' && Object.keys(excludedGroups).length > 0);
});
</script>
